<template>

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/internal-control')">Control Interno</li>
        <li class="breadcrumb-item active" aria-current="page">Reportes de Robo o Extravío</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="ml-3 mb-0" size="small" @click.stop="refreshUsersList">Actualizar lista</vs-button>
        </div>
      </div>
      <div class="row justify-content-md-center" style="margin-top:10px;">
        <div class="col-md-12">
          <md-card>
            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-head style="text-align: center">UID</md-table-head>
                  <md-table-head style="text-align: center">IID</md-table-head>
                  <md-table-head style="text-align: center">CID</md-table-head>
                  <md-table-head style="text-align: center">Nombre/Razon Social</md-table-head>
                  <md-table-head style="text-align: center">Estatus</md-table-head>
                  <md-table-head style="text-align: center">Folio de Reporte</md-table-head>
                  <md-table-head style="text-align: center">Acción</md-table-head>
                </md-table-row>
                <md-table-row v-for="user in users" :key="user.uid" >
                  <md-table-cell style="text-align: center">{{user.uid}}</md-table-cell>
                  <md-table-cell style="text-align: center">{{user.iid}}</md-table-cell>
                  <md-table-cell style="text-align: center">{{user.cid}}</md-table-cell>
                  <md-table-cell style="text-align: center">{{user.nombre}}</md-table-cell>
                  <md-table-cell style="text-align: center">{{getStatus(user.status)}}</md-table-cell>
                  <md-table-cell style="text-align: center">{{user.report_folio}}</md-table-cell>
                  <md-table-cell style="text-align: center">
                    <md-button class="md-primary" @click.stop="resetAccountRequest(user)">Reestablecer cuenta</md-button>
                  </md-table-cell>
                </md-table-row>

                <md-table-row v-if="users.length < 1">
                  <md-table-cell colspan="7">
                    <p class="bold text-center mt-6 mb-0">No se encontraron reportes pendientes</p>                    
                  </md-table-cell>
                </md-table-row>

              </md-table>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="js">
  import Vue from "vue";

  export default  {
    name: 'src-views-admin-steal-loss-reports',
    props: [],
    data() {
      return {
        users: [],
        currentUserId: null,
        currentReportId: null,
      }
    },
    async mounted() {
      await this.refreshUsersList();
    },
    methods: {
      async refreshUsersList(){
        this.showLoading(true)
        await this.getUsersList();
        this.showLoading(false)
      },
      async getUsersList(){
        try {
          const res = await axios.get('/api/compliance/ume/stealLossReport/users');
          this.users = res.data.users;
        }
        catch(e){
          this.failedOperationNotif("Error al obtener la información");
        }
      },
      getStatus(status){
        if(status === 5) return 'Cuenta bloqueada por robo o extravío';
        else return 'Solicita desbloqueo';
      },
      resetAccountRequest(user){
        this.currentUserId = user.uid;
        this.currentReportId = user.report_id;
        let mssg = `¿Desea reestablecer la cuenta asociada al reporte con folio ${user.report_folio}?`;
        this.confirmationDialog(this.doResetAccount, "Confirmar acción", mssg, "Confirmar");
      },
      async doResetAccount(){
        this.showLoading(true, "Reestableciento cuenta...")
        try {
          const payload = {
            user_id: this.currentUserId,
            report_id: this.currentReportId
          }
          const res = await axios.post( '/api/compliance/ume/stealLossReport/resolve', payload);
          await this.getUsersList();
          this.successNotifDialog("Operación exitosa","¡La cuenta ha sido reestablecida exitosamente!");
        }
        catch(e) {
          this.failedOperationNotif("Error en ejecución");
        }
        this.showLoading(false)
      }
    }
}
</script>

<style scoped lang="scss">
  .src-views-admin-steal-loss-reports {

  }
</style>
